import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-26ae270f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white border-gray-200 px-4 lg:px-6 py-2.5" }
const _hoisted_2 = { class: "flex flex-wrap justify-between items-center mx-auto max-w-screen-xl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-10 mr-4 lg:h-11",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#projects",
    class: "py-2 px-4 text-gray-700 hover:bg-gray-50 lg:hover:bg-transparent lg:hover:text-primary-700"
  }, "Projects"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#apply",
    class: "p-2 px-4 text-gray-700 hover:bg-gray-50 lg:hover:bg-transparent lg:hover:text-primary-700"
  }, "Apply")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4
      ])
    ])
  ]))
}